import * as types from './types';

const apiRequest = () => ({
  type: types.API_REQUEST
});

export default apiRequest;
